import { useQuery } from 'react-query';
import { fetchApiHealth } from '@/lib/api-health/fetch-api-health';
import {
  API_HEALTH_POLL_INTERVAL_CHECKING_MS,
  API_HEALTH_POLL_INTERVAL_HEALTHY_MS,
  API_HEALTH_POLL_INTERVAL_UNHEALTHY_MS,
  API_HEALTH_QUERY_KEY,
} from '@/lib/api-health/types';

export type ApiHealthPollMode = 'healthy' | 'checking' | 'unhealthy';

function getPollInterval(mode: ApiHealthPollMode): number {
  switch (mode) {
    case 'unhealthy':
      return API_HEALTH_POLL_INTERVAL_UNHEALTHY_MS;
    case 'checking':
      return API_HEALTH_POLL_INTERVAL_CHECKING_MS;
    default:
      return API_HEALTH_POLL_INTERVAL_HEALTHY_MS;
  }
}

type UseApiHealthOptions = {
  enabled: boolean;
  pollMode: ApiHealthPollMode;
};

export function useApiHealth({ enabled, pollMode }: UseApiHealthOptions) {
  return useQuery(API_HEALTH_QUERY_KEY, fetchApiHealth, {
    enabled,
    staleTime: 0,
    retry: 1,
    retryDelay: 2_000,
    refetchInterval: getPollInterval(pollMode),
    refetchOnWindowFocus: pollMode !== 'healthy',
  });
}
